import { createContext, useContext } from 'react';

/**
 * Oturum token'ını sorgu kancalarına taşıyan bağlam. Genel durum deposu
 * DEĞİLDİR (v1 kararı: sunucu verisi yalnız TanStack Query'de yaşar —
 * Teknoloji v1.7); burada yalnız kimlik taşınır.
 */
export const AccessTokenContext = createContext<string | null>(null);

export function useAccessToken(): string {
  const token = useContext(AccessTokenContext);
  if (!token) {
    throw new Error('AccessTokenContext sağlanmadı — bu kanca yalnız oturumlu kabukta çağrılır');
  }
  return token;
}
